import React, { useState } from "react";
import { CarouselItemHP } from "./CarouselItemHP";
import "./CarouselHP.css";

export const CarouselHP = ({ items, title }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  const updateIndex = (newIndex) => {
    if (newIndex < 0) {
      newIndex = items.length - 1;
    } else if (newIndex >= items.length) {
      newIndex = 0; // Wrap to the first item
    }
    setActiveIndex(newIndex);
  };

  return (
    <div className="carousel">
      <div className="title">
        <h3>{title}</h3>
      </div>

      <div
        className="inner"
        style={{ transform: `translate(-${activeIndex * 100}%)` }}
      >
        {items.map((item) => {
          return <CarouselItemHP item={item} width={"100%"} />;
        })}
      </div>
      <div className="carousel-buttons">
        <button
          className="button-arrowhp"
          onClick={() => {
            updateIndex(activeIndex - 1);
          }}
        >
          &lt;
        </button>
        <div className="indicators">
          {items.map((item, index) => {
            return (
              <button
                className="indicator-buttons"
                onClick={() => {
                  updateIndex(index);
                }}
              >
                <span
                  className={`material-symbols-outlined ${
                    index === activeIndex
                      ? "indicator-symbol-activeHP"
                      : "indicator-symbol"
                  }`}
                >
                  ●
                </span>
              </button>
            );
          })}
        </div>
        <button
          className="button-arrowhp"
          onClick={() => {
            updateIndex(activeIndex + 1);
          }}
        >
          &gt;
        </button>
      </div>
    </div>
  );
};

export default CarouselHP;
